import { Controller } from "stimulus";
import { submitForm } from "init/ajax";
import { parentModal } from "../modal/utils";

export default class extends Controller {
  async submit(event) {
    event.preventDefault();

    const form = event.target;
    // Consider everything valid if browser validations aren't supported
    if (!form.reportValidity || form.reportValidity()) {
      let response = await submitForm(form);
      let responseHTML = response.html;
      if(response.context) {
        if (window._learnq) {
          const context_klaviyo = JSON.parse(response.context.context);
          _learnq.push(['identify', {
            '$email': response.context.email
          }]);
          setTimeout(() => {
            _learnq.push(['track', 'forgot-password', context_klaviyo]);
          }, 100);

        }
      }

      parentModal(this.element).replaceWith(responseHTML);
    }
  }
}
